<template>
  <div class="stock-ad-view">
    <StockAD />
  </div>
</template>

<script>
import StockAD from '@/components/indicators/StockAD.vue'

export default {
  name: 'StockADView',
  components: {
    StockAD
  }
}
</script>

<style scoped>
.stock-ad-view {
  min-height: 100vh;
}
</style>
